import { ErrorCodes, isApiError } from '@/api/errors';

/**
 * Catalog key for a planned-series write error; `null` for `SUBSCRIPTION_REQUIRED`.
 * `VALIDATION_FAILED` is handled by SeriesEditorDialog / OccurrenceSheet through
 * `applyBackendFields` first; this key remains the generic fallback
 * (`planned.errorInvalid`) when those callers place nothing.
 */
export function plannedErrorKey(error: unknown): string | null {
  if (!isApiError(error)) return 'planned.errorGeneric';
  switch (error.code) {
    case ErrorCodes.SUBSCRIPTION_REQUIRED:
      return null;
    case ErrorCodes.SERIES_INVALID:
    case ErrorCodes.VALIDATION_FAILED:
      return 'planned.errorInvalid';
    case ErrorCodes.PLAN_EXCEEDS_OCCURRENCE:
      return 'planned.planExceeds';
    case ErrorCodes.FORBIDDEN:
      return 'planned.errorAuthority';
    case ErrorCodes.OCCURRENCE_RESOLVED:
      return 'planned.errorResolved';
    case ErrorCodes.OCCURRENCE_NOT_FOUND:
    case ErrorCodes.SERIES_NOT_FOUND:
      return 'planned.errorNotFound';
    case ErrorCodes.NOT_AUTO_POST:
      return 'planned.errorNotAutoPost';
    case ErrorCodes.MATCH_AMBIGUOUS:
      return 'planned.matchAmbiguous';
    case ErrorCodes.COVERAGE_BACKWARD:
      return 'accounts.coverageBackward';
    case ErrorCodes.IDEMPOTENCY_CONFLICT:
      return 'planned.errorIdempotency';
    case ErrorCodes.ALLOCATION_CURRENCY_MISMATCH:
      return 'planned.errorPartCurrency';
    default:
      return 'planned.errorGeneric';
  }
}
